module.exports = __webpack_public_path__ + "img/connect724.a3065bf1.svg";